import { create } from "zustand";
import { persist } from "zustand/middleware";
import { createSessionStoragePersist } from "../utils/sessionStoragePersist";

interface AuthStore {
  token: string | null;
  tg_id: number | null;
  setToken: (token: string) => void;
  setTgId: (tg_id: number) => void;
  clearToken: () => void;
}

export const useAuthStore = create<AuthStore>()(
  persist(
    (set) => ({
      token: null,
      tg_id: null,
      setToken: (token) => set({ token }),
      setTgId: (tg_id) => set({ tg_id }),
      clearToken: () => set({ token: null }),
    }),
    createSessionStoragePersist<AuthStore>(
      "auth",
      (state) => ({ token: state.token, tg_id: state.tg_id } as AuthStore)
    )
  )
);
